import { ErrorOutline } from '../../icons'
import { cn } from '../../utils/cn'

export type AlertProps = {
  className?: string
  icon?: React.ReactNode
  children: React.ReactNode
}

export const Alert = ({
  className,
  icon = <ErrorOutline className="shrink-0" height="16" width="16" />,
  children,
}: AlertProps) => {
  return (
    <div
      className={cn(
        'flex w-full items-center gap-2 rounded-md bg-red-04 p-2 text-red-01 typography-caption1',
        '[&_a]:underline [&_a]:underline-offset-2 [&_a]:transition-colors [&_a]:hover:text-red-02',
        className,
      )}
    >
      {icon}
      <div>{children}</div>
    </div>
  )
}
